import { createCrudSlice, createCrudSelectors } from "./CrudRedux";

const stateDefinitionsSlice = createCrudSlice({
  name: "stateDefinitions",
});

export const StateDefinitionsActions = stateDefinitionsSlice.actions;

export const StateDefinitionsSelectors = {
  ...createCrudSelectors({ name: "stateDefinitions" }),
};

export default stateDefinitionsSlice.reducer;
